import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	singleCreateWorkItemName: {
		id: 'jira-work-create-extension.single-create-work-item.name',
		defaultMessage: 'Create Jira work item',
		description: 'Name for the single create work item button',
	},
});
